var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.Opts)?_c('Select',{attrs:{"placeholder":"选择排序"},model:{value:(_vm.Opts.selectIndex),callback:function ($$v) {_vm.$set(_vm.Opts, "selectIndex", $$v)},expression:"Opts.selectIndex"}},_vm._l((_vm.items),function(item,index){return _c('Option',{key:index,attrs:{"value":index}},[_vm._v(_vm._s(item.text))])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }